import PropTypes from "prop-types";
import { MathJax } from "better-react-mathjax";

import StatusPills from "./StatusPills";

import { makeKeyFor } from "./differentiationHierarchyPanelUtils";

const EOBlock = ({ dataType, includedKeys, node, onToggleItem, selectedKeys }) => {
    const eoKey = makeKeyFor(node, dataType);
    const eoChecked = !!selectedKeys?.has?.(eoKey);
    const eoLabel = node.label?.trim() || "";
    const endsWithColon = eoLabel.endsWith(":");

    const alreadyIncluded = includedKeys?.has?.(eoKey) === true;

    return (
        <div className="diff-eo-block">
            <div className="diff-eo-block__row">
                <div className="diff-eo-block__content">
                    <span className="diff-badge diff-badge--eo">EO</span>
                    <MathJax>
                        <span dangerouslySetInnerHTML={{ __html: node.label }} />
                    </MathJax>
                </div>

                <div className="diff-eo-block__actions">
                    <StatusPills dataType={dataType} node={node} includedKeys={includedKeys} />

                    {!endsWithColon && dataType === "DIFF" && !alreadyIncluded && (
                        <div className="form-check form-check-inline align-middle m-0">
                            <input
                                className="form-check-input d-none"
                                type="checkbox"
                                checked={eoChecked}
                                onChange={() => onToggleItem?.(node)}
                                id={`add-${eoKey}`}
                            />
                            <label
                                htmlFor={`add-${eoKey}`}
                                className={`diff-action-btn ${eoChecked ? "diff-action-btn--active" : ""}`}
                            >
                                {eoChecked ? "Added" : "Add"}
                            </label>
                        </div>
                    )}
                    {!endsWithColon && dataType === "CURRENT" && (
                        <div className="form-check form-check-inline align-middle m-0">
                            <input
                                className="form-check-input d-none"
                                type="checkbox"
                                checked={eoChecked}
                                onChange={() => onToggleItem?.(node)}
                                id={`exclude-${eoKey}`}
                            />
                            <label
                                htmlFor={`exclude-${eoKey}`}
                                className={`diff-action-btn ${eoChecked ? "diff-action-btn--active" : ""}`}
                            >
                                {eoChecked ? "Excluded" : "Exclude"}
                            </label>
                        </div>
                    )}
                </div>
            </div>

            {/* EO children */}
            {Array.isArray(node.children) && node.children.length > 0 && (
                <div className="diff-eoc-list">
                    {node.children.map((eoc) => {
                        const eocKey = makeKeyFor(eoc, dataType);
                        const eocChecked = !!selectedKeys?.has?.(eocKey);
                        const eocIncluded = includedKeys?.has?.(eocKey) === true;
                        return (
                            <div key={eoc.id ?? eoc.key} className="diff-eoc-block">
                                <div className="diff-eo-block__content">
                                    <span className="diff-badge diff-badge--eoc">EOC</span>
                                    <MathJax>
                                        <span dangerouslySetInnerHTML={{ __html: eoc.label }} />
                                    </MathJax>
                                </div>

                                <div className="diff-eo-block__actions">
                                    <StatusPills dataType={dataType} node={eoc} includedKeys={includedKeys} />

                                    {dataType === "DIFF" && !eocIncluded && (
                                        <div className="form-check form-check-inline align-middle m-0">
                                            <input
                                                className="form-check-input d-none"
                                                type="checkbox"
                                                checked={eocChecked}
                                                onChange={() => onToggleItem?.(eoc)}
                                                id={`add-${eocKey}`}
                                            />
                                            <label
                                                htmlFor={`add-${eocKey}`}
                                                className={`diff-action-btn ${eocChecked ? "diff-action-btn--active" : ""}`}
                                            >
                                                {eocChecked ? "Added" : "Add"}
                                            </label>
                                        </div>
                                    )}
                                    {dataType === "CURRENT" && (
                                        <div className="form-check form-check-inline align-middle m-0">
                                            <input
                                                className="form-check-input d-none"
                                                type="checkbox"
                                                checked={eocChecked}
                                                onChange={() => onToggleItem?.(eoc)}
                                                id={`exclude-${eocKey}`}
                                            />
                                            <label
                                                htmlFor={`exclude-${eocKey}`}
                                                className={`diff-action-btn ${eocChecked ? "diff-action-btn--active" : ""}`}
                                            >
                                                {eocChecked ? "Excluded" : "Exclude"}
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

EOBlock.propTypes = {
    dataType: PropTypes.string,
    includedKeys: PropTypes.object,
    node: PropTypes.object.isRequired,
    onToggleItem: PropTypes.func,
    selectedKeys: PropTypes.instanceOf(Set)
};

EOBlock.defaultProps = {
    dataType: "",
    includedKeys: {},
    onToggleItem: () => {},
    selectedKeys: new Set()
};

export default EOBlock;
